@if (href$ | async; as href) {
    <div class="d-flex align-items-center flex-wrap gap-2"
         [ngClass]="{ 'standard-font-weight': !showIcon }">
        <a [routerLink]="href"
           class="me-1">
            @if (showIcon) {
                <span class="fa-stack fa-1x system-icon">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fa-stack-1x fa-inverse"
                       [ngClass]="icon"
                       aria-hidden="true"></i>
                </span>
            }
            <span adaptTooltip="This is a new / unsaved task map"
                  [tooltipEnabled]="system!.systemEntityId < 1">{{ system!.name }}</span>
            @if (showNavIcon) {
                <i class="ms-2 fal fa-chevron-right"></i>
            }
        </a>
        @if (accessoryText) {
            <small>{{ accessoryText }}</small>
        }
        @if (showLabels) {
            <adapt-display-labels [labelLocations]="system!.labelLocations"> </adapt-display-labels>
        }
    </div>
}
